module.exports = __webpack_public_path__ + "img/1588015313.75ddaf64.jpg";